// extracted by mini-css-extract-plugin
export var input = "search-module--input--q+KoC";
export var inputOuter = "search-module--inputOuter--vR7BM";
export var label = "search-module--label--7yL73";
export var outline = "search-module--outline--EZR79";
export var searchIcon = "search-module--searchIcon--17zIO";
export var smallHeightInput = "search-module--smallHeightInput--arLZd";